import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useTranslation } from "react-i18next";

const GeneratedDocsDialog = ({ open, onClose, docs = [], loading = false }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      BackdropProps={{
        sx: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
      }}
      PaperProps={{
        sx: { borderRadius: "20px", overflow: "hidden" },
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            bgcolor: "action.hover",
            p: 1,
            borderRadius: "10px",
            display: "flex",
          }}
        >
          <FileCopyIcon sx={{ color: "primary.main", fontSize: 20 }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 800, color: "text.primary" }}>
          {t("document.title")}
        </Typography>
      </DialogTitle>

      <Divider sx={{ borderColor: "divider" }} />

      <DialogContent sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
            <CircularProgress size={24} sx={{ color: "primary.main" }} />
          </Box>
        ) : docs.length === 0 ? (
          <Box sx={{ px: 3, py: 4 }}>
            <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
              {t("document.noDocuments")}
            </Typography>
          </Box>
        ) : (
          <List disablePadding>
            {docs.map((doc, idx) => (
              <React.Fragment key={`${doc.document_type}-${doc.document_number}-${idx}`}>
                <ListItem sx={{ px: 3, py: 1.5 }}>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontSize: 12, fontWeight: 700, color: "text.secondary", mb: 0.5 }}>
                        {doc.document_type}
                      </Typography>
                    }
                    secondary={
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "text.primary", fontFamily: "monospace" }}>
                        {doc.document_number || "—"}
                      </Typography>
                    }
                  />
                </ListItem>
                {idx < docs.length - 1 && (
                  <Divider sx={{ mx: 3, borderColor: "divider" }} />
                )}
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>

      <Box sx={{ px: 3, pb: 3, pt: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "10px",
            border: "1px solid",
            borderColor: "divider",
            color: "text.secondary",
            "&:hover": { bgcolor: "action.hover" },
          }}
        >
          {t("buttons.bClose")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default GeneratedDocsDialog;